import React, { ReactElement } from "react";

import { StickyWrapper } from "Components/StickyWrapper/StickyWrapper";
import { isDefined } from "Utils/functions";
import { MIN_DISCOUNT_VALUE } from "Utils/priceUtils";
import { DiscountValue } from "./DiscountValue";
import { InsuranceCount } from "./InsuranceCount";
import { TotalPriceValue } from "./TotalPriceValue";
import { Wrap } from "./discountMessageStyled";

interface Props {
  readonly insuranceCount?: number;
  readonly discountValue?: number;
  readonly totalPriceValue?: number;
  readonly isLoading?: boolean;
  readonly sticky?: boolean;
}

export const DiscountMessage = (props: Props): ReactElement | null => {
  const { insuranceCount, discountValue, sticky = true } = props;

  if (
    !isDefined(insuranceCount) &&
    (!isDefined(discountValue) || discountValue < MIN_DISCOUNT_VALUE)
  ) {
    return null;
  }

  if (sticky) {
    return (
      <StickyWrapper>
        <DiscountMessageContent {...props} />
      </StickyWrapper>
    );
  }

  return <DiscountMessageContent {...props} />;
};

const DiscountMessageContent = ({
  insuranceCount,
  discountValue,
  totalPriceValue,
  isLoading = false,
}: Props): ReactElement => {
  return (
    <Wrap className="discount-message">
      <InsuranceCount insuranceCount={insuranceCount} />
      <div>
        <DiscountValue discountValue={discountValue} isLoading={isLoading} />
      </div>
      <TotalPriceValue
        totalPriceValue={totalPriceValue}
        isLoading={isLoading}
      />
    </Wrap>
  );
};
